import axios from './HTTP'

export default {
  getMe (callback) {
    axios
      .get(`/api/me.json`)
      .then(response => ( callback(response.data) ))
  },

  getTimeclockMe (callback) {
    axios
      .get(`/api/timeclock_me.json`)
      .then(response => ( callback(response.data) ))
  },

  updateDefaultCalendarView (view) {
    return axios.patch(`/api/me/default_calendar_view.json`, { default_calendar_view: view })
  },
}
